module.exports = __webpack_public_path__ + "static/media/our-tomatoes.6dd92552.jpg";